import {Card, makeStyles} from '@material-ui/core';
import React from 'react';
import SearchMediaReportMasterContainer from './SearchMediaReportMasterContainer';

const useStyles = makeStyles((theme) => ({
  cardStyles: {
    'backgroundColor': '#ededed',
    'padding': 10,
    'borderRadius': 8,
    '& .MTableToolbar-root-115': {
      display: 'none',
    },
  },
}));

function SearchMediaReportMaster({setValue, handleClose, setBreCode, setRuleCode, handleDialog}) {
  const classes = useStyles();
  return (
    <div className="col-md-12">
      <Card className={classes.cardStyles} elevation={2}>
        <SearchMediaReportMasterContainer
          setValue={setValue}
          handleClose={handleClose}
          setBreCode={setBreCode}
          setRuleCode={setRuleCode}
          handleDialog={handleDialog}
        />
      </Card>
    </div>
  );
}

export default SearchMediaReportMaster;
